import { all, fork } from 'redux-saga/effects';
import { insurerSaga } from './Insurer';
import { provinceSaga } from './Province';
import { orderTemplateSaga } from './OrderTemplate';
import { companySaga } from './Company';
import { healthPlanSaga } from './HealthPlan';
import { userSaga } from './User';
import { benefitTemplateSaga } from './BenefitTemplate';
import { insurancePolicyUserSaga } from './InsurancePolicyUser';
import { ingestionSaga } from './Ingestion';

export default function* () {
  yield all([
    fork(insurerSaga),
    fork(provinceSaga),
    fork(orderTemplateSaga),
    fork(companySaga),
    fork(healthPlanSaga),
    fork(userSaga),
    fork(benefitTemplateSaga),
    fork(insurancePolicyUserSaga),
    fork(ingestionSaga)
  ]);
}
